import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 111.21 114.47"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M48.49 0 38.26 5.91l14.57 40.61-37.48 4.12 26.69 22.43L0 78.66v5.24l37.48-4.35-28.8 17.07 38.59-4.69-25.69 15.4 3.78 3.57 31.47-18.86 12.79 22.09 16.01-21.2 14.68 17.63 10.9-3.68-35.7-25.22 24.91-14.17-8.12 1-1.56-2.12-29.02 3.13L48.49 0Zm-.78 52.55-1 4.02-8.01.89 6.12 5.24-1.22 4.57L27.7 54.1l20.01-1.56Zm-2.45 27.89 3.67 5.8-16.35 2.34 12.68-8.14Zm17.35 11.92h5.12l3.34 5.26 3.89-5.26h4.78l-10.01 14.41-7.12-14.41ZM24.8 19.52l5.12 12.5-11.79.22 6.67-12.72ZM34.92 8.37l-7.67 5.91 7.56 21.2-19.46 2.01-3 8.03 35.14-3.24L34.92 8.36ZM11.68 53l-.22 3.9 11.45 10.38-10.68 1.12 1.22 5.02 19.91-3.01-21.68-17.4ZM1.22 86.92l3.67 6.92 16.13-9.26-19.8 2.34Zm11.23 13.16 5.45 4.57 12.23-6.81-17.68 2.23Zm70.85 14.28 2.78-4.13 2.45 3.01-5.23 1.12Zm12.45-3.46-2.78 1.67-7.23-8.37-7.23 10.26H74.4l11.23-15.4 10.12 11.83Zm-31.25 3.57-8.9-17.29-14.9 7.81 2.89 3.57 10.24-5.36 5.34 9.71 5.34 1.56Z",
      style: {"fill":"#dc1f02","fill-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "TM-logo"}) } }